import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=40033c16&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=ts&"
export * from "./AddDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=40033c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40033c16",
  null
  
)

export default component.exports